<div style="max-width: 900px; margin: 0 auto; padding-top: 2em; margin-bottom: 20px;">
  @if (surveyForm && surveyForm.get('answers') && surveyForm.get('answers').value != null) {
    <form #SurveyForm="ngForm" [formGroup]="surveyForm.get('answers')">
      @if (surveyStructure && !submitted) {
        <mat-horizontal-stepper [linear]="true" class="mat-elevation-z4" style="border-radius: 5px;" #stepper>
          @for (category of getCategories(); track category) {
            <mat-step [stepControl]="getStepControl(category)">
              <ng-template matStepLabel>{{category.name}}</ng-template> <span class="category-description">{{category.description}}</span>
              @for (question of getQuestions(category); track question) {
                <mat-card appearance="outlined" class="survey-card">
                  <mat-card-title>{{question.questionText}} @if (question.required) {
                    <span style="color: #F11212;">*</span>
                  } </mat-card-title>
                  <mat-card-content>
                    @switch (question.questionType) {
                      @case (SurveyQuestionType.Bool) {
                        <mat-radio-group  required [formControlName]="question.propertyName" class="survey-radio-bool">
                          <mat-radio-button name="test" [value]="true">True</mat-radio-button>
                          <mat-radio-button [value]="false">False</mat-radio-button>
                        </mat-radio-group>
                      }
                      @case (SurveyQuestionType.YesNo) {
                        <mat-radio-group #test1 required [formControlName]="question.propertyName" class="survey-radio-yesno">
                          <mat-radio-button [value]="true">Yes</mat-radio-button>
                          <mat-radio-button [value]="false">No</mat-radio-button>
                        </mat-radio-group>
                      }
                      @case (SurveyQuestionType.Multi) {
                        <mat-radio-group required [formControlName]="question.propertyName" class="survey-radio-multi">
                          @for (option of getAnswers(question); track option) {
                            <mat-radio-button [value]="option.value">{{option.text}} </mat-radio-button>
                          }
                        </mat-radio-group>
                      }
                      @case (SurveyQuestionType.Range) {
                        <mat-radio-group required [formControlName]="question.propertyName" class="survey-radio-range">
                          @for (option of getAnswers(question); track option) {
                            <mat-radio-button [value]="option.value">{{option.text}} </mat-radio-button>
                          }
                        </mat-radio-group>
                      }
                      @case (SurveyQuestionType.Text) {
                        <mat-form-field>
                          <mat-label>
                            <mat-icon>edit</mat-icon>
                          </mat-label>
                        <input matInput [formControlName]="question.propertyName" type="text" placeholder="Your Answer..." /> </mat-form-field>
                      }
                      @case (SurveyQuestionType.Check) {
                        <mat-checkbox [formControlName]="question.propertyName"></mat-checkbox>
                      }
                      @default {
                        <!--None-->
                      }
                    }
                  </mat-card-content>
                </mat-card>
              }
              <div class="step-btn-box">
                @if (stepper.selectedIndex != 0) {
                  <button type="button" color="accent" mat-stroked-button matStepperPrevious>Back</button>
                }
                @if (stepper.selectedIndex != surveyStructure.categories.length-1) {
                  <button type="button" color="primary" [disabled]="isStepValid(category)" mat-raised-button matStepperNext>Next</button>
                }
                @if (stepper.selectedIndex == surveyStructure.categories.length-1) {
                  <button type="button" color="primary" [disabled]="!SurveyForm.valid" mat-raised-button (click)="saveSurvey()">Complete</button>
                  } <span style="color: #F11212; float: right;"> * - required</span> </div>
                </mat-step>
              }
            </mat-horizontal-stepper>
          }
        </form>
      }
      @if (submitted) {
        <div class="mat-elevation-z4" style="background: #FFF; padding: 1.2em; border-radius: 5px; color: #404040">
          <h3>Thank You!</h3>
          <p> Your feedback is greatly appreciated and helps towards making everyones experience great. </p>
        </div>
      }
    </div>